import { Text, Stack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { useRedeemSummaryContext } from '../../../../contexts/redeem-summary';
import { SKELETON_PROPS } from '../../../../utils/constants';

interface StatusSectionProps {
  title: string | React.ReactNode;
  status: React.ReactNode;
}

export const StatusSection: React.FC<StatusSectionProps> = ({ title, status }) => {
  const { isLoadingRedeemSummary, isLoadingRedeemRowsSummary } = useRedeemSummaryContext();

  const isLoading = isLoadingRedeemSummary || isLoadingRedeemRowsSummary;

  return (
    <Stack
      space={Spacing['inset.quarck']}
      direction={{ base: 'row', lg: 'column' }}
      alignSelf="center"
      w={{ base: 'full', lg: 'container' }}
      minW={{ base: 'full', lg: '74px' }}
      justifyContent="space-between">
      <Text color="neutral.darkest" variant={{ base: 'regular', lg: 'semibold' }}>
        {title}
      </Text>
      {!isLoading && status}
      {isLoading && <Skeleton {...SKELETON_PROPS} />}
    </Stack>
  );
};
